'use client'

import { GameIsAdminOnly } from 'app/components/GameIsAdminOnly'
import GameDescriptionPageViaBuilder from 'src/pageContainers/GameDescriptionPageViaBuilder'

const GAME_DESCRIPTION_PAGE_MODEL = process.env.GAME_DESCRIPTION

export function SlotsGamePageContainerClient({ page, providerCodes }: any) {
  return (
    <GameIsAdminOnly gameLaunchDate={page.gameProduct.launchDate} showLoader>
      <GameDescriptionPageViaBuilder
        pageProps={page}
        pageModel={GAME_DESCRIPTION_PAGE_MODEL}
        providerCodes={providerCodes}
      />
    </GameIsAdminOnly>
  )
}
